// src/config/payfast.js

// PayFast Configuration
// Replace these with your actual PayFast credentials

const PAYFAST_CONFIG = {
  sandbox: {
    merchant_id: process.env.REACT_APP_PAYFAST_SANDBOX_MERCHANT_ID,
    merchant_key: process.env.REACT_APP_PAYFAST_SANDBOX_MERCHANT_KEY,
    passphrase: process.env.REACT_APP_PAYFAST_SANDBOX_PASSPHRASE || '',
    url: 'https://sandbox.payfast.co.za/eng/process',
  },
  live: {
    merchant_id: process.env.REACT_APP_PAYFAST_MERCHANT_ID,
    merchant_key: process.env.REACT_APP_PAYFAST_MERCHANT_KEY,
    passphrase: process.env.REACT_APP_PAYFAST_PASSPHRASE || '',
    url: 'https://www.payfast.co.za/eng/process',
  },
};

const getEnvironment = () =>
  (process.env.REACT_APP_PAYFAST_ENV || 'live').toLowerCase() === 'sandbox'
    ? 'sandbox'
    : 'live';

// Get current configuration based on environment
export const getPayFastConfig = () => {
  const environment = getEnvironment();
  const config = PAYFAST_CONFIG[environment];

  return {
    merchant_id: config.merchant_id,
    merchant_key: config.merchant_key,
    passphrase: config.passphrase,
    payment_url: config.url,
    is_sandbox: environment === 'sandbox',
    environment,
  };
};

// Validate configuration
export const validatePayFastConfig = () => {
  const config = getPayFastConfig();
  
  const errors = [];
  
  if (!config.merchant_id) {
    errors.push('PayFast merchant ID is required');
  }
  
  if (!config.merchant_key) {
    errors.push('PayFast merchant key is required');
  }
  
  // Passphrase is optional but recommended
  if (!config.passphrase && config.environment === 'live') {
    // PayFast passphrase is recommended for production
  }
  
  return {
    isValid: errors.length === 0,
    errors,
    config
  };
};

// PayFast ITN URLs (for webhook notifications)
export const getPayFastITNUrls = () => {
  const envReturn = process.env.REACT_APP_PAYFAST_RETURN_URL;
  const envCancel = process.env.REACT_APP_PAYFAST_CANCEL_URL;
  const envNotify =
    process.env.REACT_APP_PAYFAST_NOTIFY_URL ||
    'https://us-central1-pontshoyarona.cloudfunctions.net/api/payfast/notify';

  const baseUrl =
    process.env.REACT_APP_BASE_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '');

  const defaultReturn = baseUrl ? `${baseUrl}/payment/success` : '';
  const defaultCancel = baseUrl ? `${baseUrl}/payment/cancelled` : '';
  
  return {
    notify_url: envNotify,
    return_url: envReturn || defaultReturn,
    cancel_url: envCancel || defaultCancel
  };
};

// Payment limits and validation rules
export const PAYFAST_LIMITS = {
  min_amount: 5.00, // Minimum R5.00
  max_amount: 1000000.00, // Maximum R1,000,000.00
  currency: 'ZAR',
  supported_countries: ['ZA'] // Only South Africa
};

// Test card numbers for sandbox
export const PAYFAST_TEST_CARDS = {
  successful: {
    number: '4000000000000002',
    expiry: '12/25',
    cvv: '123',
    description: 'Successful test transaction'
  },
  insufficient_funds: {
    number: '4000000000000010',
    expiry: '12/25',
    cvv: '123',
    description: 'Insufficient funds'
  },
  declined: {
    number: '4000000000000028',
    expiry: '12/25',
    cvv: '123',
    description: 'Declined transaction'
  },
  expired_card: {
    number: '4000000000000036',
    expiry: '12/25',
    cvv: '123',
    description: 'Expired card'
  }
};

export default PAYFAST_CONFIG;